/* Auto-generated — run: npm run build:southlands-progress */

import type { ProgressCarouselItem } from '../components/ProgressStageCarousel';

export type SouthlandsProgressStage = {
  date: string;
  title: string;
  items: ProgressCarouselItem[];
};

export const SOUTHLANDS_PROGRESS_STAGES: SouthlandsProgressStage[] = [
  {
    "date": "March 2026",
    "title": "Roof Steelwork and M&E Start",
    "items": [
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/000.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 1 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/001.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 2 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/002.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 3 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/003.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 4 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/004.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 5 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/005.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 6 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/006.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 7 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/007.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 8 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/008.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 9 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/009.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 10 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/010.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 11 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/011.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 12 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/012.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 13 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/013.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 14 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/014.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 15 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/015.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 16 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/016.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 17 of 18"
      },
      {
        "src": "/progress/southlands/15-roof-steelwork-and-mande-start/017.jpg",
        "type": "image",
        "alt": "Roof Steelwork and M&E Start, photo 18 of 18"
      }
    ]
  },
  {
    "date": "February 2026",
    "title": "FF Planks and Masonry",
    "items": [
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/000.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 1 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/001.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 2 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/002.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 3 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/003.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 4 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/004.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 5 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/005.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 6 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/006.mp4",
        "type": "video"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/007.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 8 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/008.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 9 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/009.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 10 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/010.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 11 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/011.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 12 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/012.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 13 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/013.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 14 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/014.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 15 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/015.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 16 of 17"
      },
      {
        "src": "/progress/southlands/14-ff-planks-and-masonry/016.jpg",
        "type": "image",
        "alt": "FF Planks and Masonry, photo 17 of 17"
      }
    ]
  },
  {
    "date": "January 2026",
    "title": "FF Structural Steel",
    "items": [
      {
        "src": "/progress/southlands/13-ff-structural-steel/000.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 1 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/001.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 2 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/002.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 3 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/003.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 4 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/004.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 5 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/005.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 6 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/006.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 7 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/007.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 8 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/008.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 9 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/009.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 10 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/010.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 11 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/011.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 12 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/012.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 13 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/013.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 14 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/014.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 15 of 16"
      },
      {
        "src": "/progress/southlands/13-ff-structural-steel/015.jpg",
        "type": "image",
        "alt": "FF Structural Steel, photo 16 of 16"
      }
    ]
  },
  {
    "date": "December 2025",
    "title": "GF Masonry and Screeding",
    "items": [
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/000.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 1 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/001.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 2 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/002.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 3 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/003.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 4 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/004.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 5 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/005.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 6 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/006.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 7 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/007.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 8 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/008.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 9 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/009.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 10 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/010.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 11 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/011.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 12 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/012.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 13 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/013.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 14 of 15"
      },
      {
        "src": "/progress/southlands/12-gf-masonry-and-screeding/014.jpg",
        "type": "image",
        "alt": "GF Masonry and Screeding, photo 15 of 15"
      }
    ]
  },
  {
    "date": "November 2025",
    "title": "GF Planks and Masonry",
    "items": [
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/000.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 1 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/001.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 2 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/002.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 3 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/003.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 4 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/004.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 5 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/005.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 6 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/006.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 7 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/007.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 8 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/008.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 9 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/009.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 10 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/010.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 11 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/011.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 12 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/012.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 13 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/013.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 14 of 15"
      },
      {
        "src": "/progress/southlands/11-gf-planks-and-masonry/014.jpg",
        "type": "image",
        "alt": "GF Planks and Masonry, photo 15 of 15"
      }
    ]
  },
  {
    "date": "September 2025",
    "title": "LGF Floors",
    "items": [
      {
        "src": "/progress/southlands/10-lgf-floors/000.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 1 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/001.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 2 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/002.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 3 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/003.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 4 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/004.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 5 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/005.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 6 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/006.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 7 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/007.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 8 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/008.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 9 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/009.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 10 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/010.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 11 of 12"
      },
      {
        "src": "/progress/southlands/10-lgf-floors/011.jpg",
        "type": "image",
        "alt": "LGF Floors, photo 12 of 12"
      }
    ]
  },
  {
    "date": "July '25",
    "title": "Substructures Commencement",
    "items": [
      {
        "src": "/progress/southlands/09-substructures-commencement/000.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 1 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/001.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 2 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/002.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 3 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/003.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 4 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/004.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 5 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/005.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 6 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/006.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 7 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/007.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 8 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/008.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 9 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/009.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 10 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/010.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 11 of 12"
      },
      {
        "src": "/progress/southlands/09-substructures-commencement/011.jpg",
        "type": "image",
        "alt": "Substructures Commencement, photo 12 of 12"
      }
    ]
  },
  {
    "date": "June '25",
    "title": "Drone Video",
    "items": [
      {
        "src": "/progress/southlands/08-drone-video/000.jpg",
        "type": "image",
        "alt": "Drone Video, photo 1 of 5"
      },
      {
        "src": "/progress/southlands/08-drone-video/001.jpg",
        "type": "image",
        "alt": "Drone Video, photo 2 of 5"
      },
      {
        "src": "/progress/southlands/08-drone-video/002.jpg",
        "type": "image",
        "alt": "Drone Video, photo 3 of 5"
      },
      {
        "src": "/progress/southlands/08-drone-video/004.jpg",
        "type": "image",
        "alt": "Drone Video, photo 5 of 5"
      }
    ]
  },
  {
    "date": "June '25",
    "title": "Month 1 Progress",
    "items": [
      {
        "src": "/progress/southlands/07-month-1-progress/000.jpg",
        "type": "image",
        "alt": "Month 1 Progress, photo 1 of 6"
      },
      {
        "src": "/progress/southlands/07-month-1-progress/001.jpg",
        "type": "image",
        "alt": "Month 1 Progress, photo 2 of 6"
      },
      {
        "src": "/progress/southlands/07-month-1-progress/002.jpg",
        "type": "image",
        "alt": "Month 1 Progress, photo 3 of 6"
      },
      {
        "src": "/progress/southlands/07-month-1-progress/003.jpg",
        "type": "image",
        "alt": "Month 1 Progress, photo 4 of 6"
      },
      {
        "src": "/progress/southlands/07-month-1-progress/004.jpg",
        "type": "image",
        "alt": "Month 1 Progress, photo 5 of 6"
      },
      {
        "src": "/progress/southlands/07-month-1-progress/005.jpg",
        "type": "image",
        "alt": "Month 1 Progress, photo 6 of 6"
      }
    ]
  },
  {
    "date": "",
    "title": "First 2 weeks on Site Time Lapse",
    "items": [
      {
        "src": "/progress/southlands/06-first-2-weeks-on-site-time-lapse/000.mp4",
        "type": "video"
      }
    ]
  },
  {
    "date": "June 2025",
    "title": "Contract Start",
    "items": [
      {
        "src": "/progress/southlands/05-contract-start/000.jpg",
        "type": "image",
        "alt": "Contract Start, photo 1 of 9"
      },
      {
        "src": "/progress/southlands/05-contract-start/001.mp4",
        "type": "video"
      },
      {
        "src": "/progress/southlands/05-contract-start/002.jpg",
        "type": "image",
        "alt": "Contract Start, photo 3 of 9"
      },
      {
        "src": "/progress/southlands/05-contract-start/003.jpg",
        "type": "image",
        "alt": "Contract Start, photo 4 of 9"
      },
      {
        "src": "/progress/southlands/05-contract-start/004.jpg",
        "type": "image",
        "alt": "Contract Start, photo 5 of 9"
      },
      {
        "src": "/progress/southlands/05-contract-start/005.jpg",
        "type": "image",
        "alt": "Contract Start, photo 6 of 9"
      },
      {
        "src": "/progress/southlands/05-contract-start/006.jpg",
        "type": "image",
        "alt": "Contract Start, photo 7 of 9"
      },
      {
        "src": "/progress/southlands/05-contract-start/007.jpg",
        "type": "image",
        "alt": "Contract Start, photo 8 of 9"
      },
      {
        "src": "/progress/southlands/05-contract-start/008.jpg",
        "type": "image",
        "alt": "Contract Start, photo 9 of 9"
      }
    ]
  },
  {
    "date": "April 2025",
    "title": "Final Reptile Mitigation",
    "items": [
      {
        "src": "/progress/southlands/04-final-reptile-mitigation/000.jpg",
        "type": "image",
        "alt": "Final Reptile Mitigation, photo 1 of 9"
      },
      {
        "src": "/progress/southlands/04-final-reptile-mitigation/001.jpg",
        "type": "image",
        "alt": "Final Reptile Mitigation, photo 2 of 9"
      },
      {
        "src": "/progress/southlands/04-final-reptile-mitigation/002.jpg",
        "type": "image",
        "alt": "Final Reptile Mitigation, photo 3 of 9"
      },
      {
        "src": "/progress/southlands/04-final-reptile-mitigation/003.jpg",
        "type": "image",
        "alt": "Final Reptile Mitigation, photo 4 of 9"
      },
      {
        "src": "/progress/southlands/04-final-reptile-mitigation/004.jpg",
        "type": "image",
        "alt": "Final Reptile Mitigation, photo 5 of 9"
      },
      {
        "src": "/progress/southlands/04-final-reptile-mitigation/005.jpg",
        "type": "image",
        "alt": "Final Reptile Mitigation, photo 6 of 9"
      },
      {
        "src": "/progress/southlands/04-final-reptile-mitigation/006.jpg",
        "type": "image",
        "alt": "Final Reptile Mitigation, photo 7 of 9"
      },
      {
        "src": "/progress/southlands/04-final-reptile-mitigation/007.jpg",
        "type": "image",
        "alt": "Final Reptile Mitigation, photo 8 of 9"
      },
      {
        "src": "/progress/southlands/04-final-reptile-mitigation/008.jpg",
        "type": "image",
        "alt": "Final Reptile Mitigation, photo 9 of 9"
      }
    ]
  },
  {
    "date": "March 2025",
    "title": "Enabling and Drainage",
    "items": [
      {
        "src": "/progress/southlands/02-enabling-and-drainage/000.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 1 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/001.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 2 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/002.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 3 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/003.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 4 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/004.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 5 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/005.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 6 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/006.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 7 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/007.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 8 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/008.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 9 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/009.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 10 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/010.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 11 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/011.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 12 of 13"
      },
      {
        "src": "/progress/southlands/02-enabling-and-drainage/012.jpg",
        "type": "image",
        "alt": "Enabling and Drainage, photo 13 of 13"
      }
    ]
  },
  {
    "date": "January 2025",
    "title": "Demolition",
    "items": [
      {
        "src": "/progress/southlands/01-demolition/000.jpg",
        "type": "image",
        "alt": "Demolition, photo 1 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/001.jpg",
        "type": "image",
        "alt": "Demolition, photo 2 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/002.jpg",
        "type": "image",
        "alt": "Demolition, photo 3 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/003.jpg",
        "type": "image",
        "alt": "Demolition, photo 4 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/004.jpg",
        "type": "image",
        "alt": "Demolition, photo 5 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/005.jpg",
        "type": "image",
        "alt": "Demolition, photo 6 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/006.jpg",
        "type": "image",
        "alt": "Demolition, photo 7 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/007.jpg",
        "type": "image",
        "alt": "Demolition, photo 8 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/008.jpg",
        "type": "image",
        "alt": "Demolition, photo 9 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/009.jpg",
        "type": "image",
        "alt": "Demolition, photo 10 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/010.jpg",
        "type": "image",
        "alt": "Demolition, photo 11 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/011.jpg",
        "type": "image",
        "alt": "Demolition, photo 12 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/012.mp4",
        "type": "video"
      },
      {
        "src": "/progress/southlands/01-demolition/013.jpg",
        "type": "image",
        "alt": "Demolition, photo 14 of 15"
      },
      {
        "src": "/progress/southlands/01-demolition/014.jpg",
        "type": "image",
        "alt": "Demolition, photo 15 of 15"
      }
    ]
  },
  {
    "date": "June 2024",
    "title": "Site Overview: Pre-Construction",
    "items": [
      {
        "src": "/progress/southlands/00-pre-start-photos/000.jpg",
        "type": "image",
        "alt": "Site Overview: Pre-Construction, photo 1 of 10"
      },
      {
        "src": "/progress/southlands/00-pre-start-photos/001.jpg",
        "type": "image",
        "alt": "Site Overview: Pre-Construction, photo 2 of 10"
      },
      {
        "src": "/progress/southlands/00-pre-start-photos/002.jpg",
        "type": "image",
        "alt": "Site Overview: Pre-Construction, photo 3 of 10"
      },
      {
        "src": "/progress/southlands/00-pre-start-photos/003.jpg",
        "type": "image",
        "alt": "Site Overview: Pre-Construction, photo 4 of 10"
      },
      {
        "src": "/progress/southlands/00-pre-start-photos/004.jpg",
        "type": "image",
        "alt": "Site Overview: Pre-Construction, photo 5 of 10"
      },
      {
        "src": "/progress/southlands/00-pre-start-photos/005.jpg",
        "type": "image",
        "alt": "Site Overview: Pre-Construction, photo 6 of 10"
      },
      {
        "src": "/progress/southlands/00-pre-start-photos/006.jpg",
        "type": "image",
        "alt": "Site Overview: Pre-Construction, photo 7 of 10"
      },
      {
        "src": "/progress/southlands/00-pre-start-photos/007.jpg",
        "type": "image",
        "alt": "Site Overview: Pre-Construction, photo 8 of 10"
      },
      {
        "src": "/progress/southlands/00-pre-start-photos/008.jpg",
        "type": "image",
        "alt": "Site Overview: Pre-Construction, photo 9 of 10"
      },
      {
        "src": "/progress/southlands/00-pre-start-photos/009.jpg",
        "type": "image",
        "alt": "Site Overview: Pre-Construction, photo 10 of 10"
      }
    ]
  }
];
